export default "__VITE_ASSET__B4xVfj8V__"